import ApiResponseError from 'lib/errors/ApiResponseError';

export const isFieldSchemaError = (error: ApiResponseError | undefined) => {
  return (
    error?.status === 422 &&
    error?.errors?.[0]?.source?.pointer &&
    fieldSchemaPointers.includes(error?.errors?.[0]?.source?.pointer)
  );
};

const fieldSchemaPointers = [
  // AccountType
  '/data/attributes/field-schemas',
  // CaseTemplate
  '/data/attributes/configuration/field-schema',
];

export const fieldSchemaErrorMessage = (
  error: ApiResponseError | undefined,
  fallback: string = 'Validation failed',
): string => {
  const relevantError = (error?.errors || []).find((e) => {
    return e.source?.pointer && fieldSchemaPointers.includes(e.source.pointer);
  });

  if (relevantError?.details != null) {
    if (typeof relevantError.details === 'string') {
      return relevantError.details;
    } else {
      return fallback;
    }
  } else {
    return fallback;
  }
};
